{{#if secondaryButtons}}
  <div class="btn-group">
    {{#if primaryButton}}
      <button type="button" class="btn btn-xs btn-tertiary" data-index="-1">{{primaryButton.label}}</button>
      <button type="button" class="btn btn-xs btn-tertiary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <span class="caret"></span>
        <span class="sr-only">Toggle Dropdown</span>
      </button>
    {{else}}
      <button type="button" class="btn btn-sm btn-tertiary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" xml:space="preserve"><title>{{locale "grid.toggleDropdown"}}</title><path d="M7.985 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/></svg>
      </button>
    {{/if}}

    <ul class="dropdown-menu" id="grid-dropdown-{{cid}}">
      {{#each secondaryButtons}}
        {{#if header}}
          <li class="dropdown-header">{{label}}</li>
        {{else if separator}}
          <li role="separator" class="divider"></li>
        {{else}}
          <li><a href="#" data-index="{{@index}}">{{label}}</a></li>
        {{/if}}
      {{/each}}
    </ul>
  </div>
{{else}}
  {{#if primaryButton}}
    <button
      type="button"
      class="btn btn-xs btn-tertiary"
      data-index="-1"
      {{#if addTitleToPrimaryButton}}title="{{primaryButton.label}}"{{/if}}
    >
      {{primaryButton.label}}
    </button>
  {{/if}}
{{/if}}
